import Filter from '../../src/legacy/Filter.tsx';
export default Filter;
